// extracted by mini-css-extract-plugin
export default {"rows":"q7f03XpzMTNV_JkcTQ3K","row":"fObw5sQSO_JiIQgWNm_j","partial":"P4fad0sh78PFF1FAAsBw","label":"Ey6zo9OZgRQm_ycPHTpA","partialFirstRow":"ImW_FCRrHB_F4FOCJ_Lr"};